(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2058],{

/***/ 14060:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/dashboard",
      function () {
        return __webpack_require__(276);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);



const NoData = ()=>{
    var ref, ref1, ref2;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const [isDisplay, setIsDisplay] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const email = ((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.email) || "";
    const allDeviceUser = JSON.parse(localStorage.getItem("allDeviceUser")) || [];
    const time = (allDeviceUser === null || allDeviceUser === void 0 ? void 0 : (ref2 = allDeviceUser[0]) === null || ref2 === void 0 ? void 0 : ref2.createdAt) || null;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!email || !time) return;
        const inputTime = new Date(time).getTime();
        const now = Date.now();
        const oneHourAgo = now - 60 * 60 * 1000;
        const shouldDisplay = inputTime > oneHourAgo;
        setIsDisplay(shouldDisplay);
        localStorage.setItem("isDisplay-".concat(email), JSON.stringify(shouldDisplay));
    }, [
        email,
        time
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!email) return;
        const stored = localStorage.getItem("isDisplay-".concat(email));
        setIsDisplay(stored === "true");
    }, [
        email
    ]);
    const NoDisplay = ()=>{
        setIsDisplay(false);
        localStorage.setItem("isDisplay-".concat(email), JSON.stringify(false));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isDisplay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "[box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white p-5 pt-1 mb-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "text-[28px] h-[30px] smjs:translate-y-[20px]",
                        onClick: ()=>NoDisplay(),
                        children: "\xd7"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/welcome.svg",
                            width: 32,
                            height: 32,
                            alt: "welcome",
                            className: "w-[32px] h-[32px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ml-5 smjs:pr-6",
                            children: t("Welcome We")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(66242);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(44267);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(60770);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(75398);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34745);
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53399);
/* harmony import */ var _src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95629);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9473);
/* harmony import */ var src_components_FirstBinding__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80671);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29143);
/* harmony import */ var src_components_ExpirationReminder__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40726);
/* harmony import */ var src_components_DisconnectDetection__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12123);
/* harmony import */ var src_utils_refreshSubscriptionExpire__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49354);
/* harmony import */ var src_utils_orderLevel__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(23269);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(74743);
/* harmony import */ var src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22518);
/* harmony import */ var src_utils_currentOrder__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(34556);
/* harmony import */ var src_core_components_android_login__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52850);













// components













const Dashboard1 = ()=>{
    var ref;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    // 异步 Dashboard 拉数归属键，切换设备后旧请求结果会被忽略
    const deviceRequestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_6__/* .selectDeviceRequestKey */ .rx);
    const deviceRequestKeyRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(deviceRequestKey);
    deviceRequestKeyRef.current = deviceRequestKey;
    let Basic = window.localStorage.getItem("Basic");
    Basic = Basic == null || Basic == 0 ? true : false;
    if (window.localStorage.getItem("addDevice") == "1") {
        Basic = true;
    }
    // 基础数据模块
    const [typeModule, setTypeModule] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        {
            id: 1,
            name: "Text Messages",
            img: "/images/dashboard/new-android/message.svg",
            num: 0,
            href: "/android/text-messages",
            eventName: "Click_Textmessages"
        },
        {
            id: 2,
            name: "WhatsApp",
            img: "/images/dashboard/new-android/whatsapp.svg",
            num: 0,
            href: "/android/whatsapp",
            eventName: "Click_WhatsApp"
        },
        {
            id: 3,
            name: "Locations",
            img: "/images/dashboard/new-android/gps.svg",
            num: 0,
            href: "/android/locations",
            eventName: "Click_GPSlocation"
        },
        {
            id: 4,
            name: "Photo",
            img: "/images/dashboard/new-android/photos.png",
            num: 0,
            href: "/android/photos",
            eventName: "Click_Photo"
        },
        {
            id: 5,
            name: "Video",
            img: "/images/dashboard/new-android/video.svg",
            num: 0,
            href: "/android/videos",
            eventName: "Click_Video"
        },
        {
            id: 6,
            name: "Email",
            img: "/images/dashboard/new-android/gmail.svg",
            num: 0,
            href: "/android/email",
            eventName: "Click_Email"
        },
        {
            id: 7,
            name: "Contact",
            img: "/images/dashboard/new-android/contacts.svg",
            num: 0,
            href: "/android/contacts",
            eventName: "Click_Contact"
        },
        {
            id: 8,
            name: "Browser history",
            img: "/images/dashboard/new-android/google-chrome.svg",
            num: 0,
            href: "/android/browser-history",
            eventName: "Click_Browserhistory"
        },
        {
            id: 9,
            name: "Browser Bookmark",
            img: "/images/dashboard/new-android/bookmarks.svg",
            num: 0,
            href: "/android/browser-bookmark",
            eventName: "Click_Browserbookmark"
        },
        {
            id: 10,
            name: "Wi-Fi Networks",
            img: "/images/dashboard/new-android/wifi.svg",
            num: 0,
            href: "/android/wifi-networks",
            eventName: "Click_Wifinetwork"
        },
        {
            id: 11,
            name: "Keep",
            img: "/images/dashboard/new-android/keep.svg",
            num: 0,
            href: "/android/keep",
            eventName: "Click_Keep"
        }
    ]);
    // 克隆列表
    const [cloneList, setCloneList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    // 数据量最多的常用app列表
    const [frequentlyArr, setFrequentlyArr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    //初始化列表
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (window.innerWidth < 780 && typeModule && typeModule.length > 0) {
            // 过滤出指定 name 的 icon 并按 num 值降序排序
            let selectedIcons = typeModule.filter((icon)=>{
                return [
                    "Text Messages",
                    "WhatsApp",
                    "Email",
                    "Locations",
                    "Photo",
                    "Video",
                    "Browser history",
                    "Browser Bookmark",
                    "Wi-Fi Networks"
                ].includes(icon.name) && icon.num > 0;
            });
            if (selectedIcons.length === 0) {
                return;
            }
            // 过滤出不在 selectedIcons 中的其他 icon 并按 num 值降序排序
            let _selectedIcons = typeModule.filter((icon)=>!([
                    "Text Messages",
                    "WhatsApp",
                    "Email",
                    "Locations",
                    "Photo",
                    "Video",
                    "Browser history",
                    "Browser Bookmark",
                    "Wi-Fi Networks"
                ].includes(icon.name) && icon.num > 0)).sort((a, b)=>b.num - a.num);
            setCloneList([
                ...selectedIcons,
                ..._selectedIcons
            ].slice(0, 9));
            localStorage.setItem("frequentlyArr", JSON.stringify([
                ...selectedIcons,
                ..._selectedIcons
            ].sort((a, b)=>b.num - a.num).slice(0, 3)));
            setFrequentlyArr([
                ...selectedIcons,
                ..._selectedIcons
            ].sort((a, b)=>b.num - a.num).slice(0, 3));
        } else {
            setCloneList(typeModule);
            localStorage.setItem("frequentlyArr", JSON.stringify([
                ...typeModule
            ].sort((a, b)=>b.num - a.num).slice(0, 3)));
            setFrequentlyArr([
                ...typeModule
            ].sort((a, b)=>b.num - a.num).slice(0, 3));
        }
    }, [
        typeModule
    ]);
    const getData = async (requestKey)=>{
        setIsLoading(true);
        let list = typeModule.map((item)=>({
                ...item
            }));
        let deviceUser = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        if (deviceUser == "") {
            setIsLoading(false);
            return;
        }
        try {
            var ref;
            let all = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .getGcloudAll */ .U1)({
                username: deviceUser,
                params: {
                    category: "USER_SUMMARY",
                    offset: 0,
                    limit: 4
                }
            });
            if (deviceRequestKeyRef.current !== requestKey) return;
            const summary = all === null || all === void 0 ? void 0 : (ref = all.data) === null || ref === void 0 ? void 0 : ref.summary;
            if (!summary || typeof summary !== "object") {
                setIsLoading(false);
                return;
            }
            if (Array.isArray(summary.advance)) setTargetDeviceList(summary.advance);
            if (all.code === 1002) {
                setIsLoading(false);
                return;
            }
            let deviceUdid = JSON.parse(localStorage.getItem("currentDevice")) != null ? JSON.parse(localStorage.getItem("currentDevice"))["id"] : "";
            try {
                list[1].num = summary.whatsapp;
                list[2].num = summary.location;
                list[3].num = summary.photo;
                list[4].num = summary.video;
                list[5].num = summary.gmail;
                list[6].num = summary.contact;
                list[7].num = summary.chrome_history;
                list[8].num = summary.chrome_bookmark;
                list[9].num = summary.wifi;
                list[10].num = summary.keep;
                // 获取短信
                if (Array.isArray(summary.advance)) {
                    let find = summary.advance.find((row)=>{
                        if (row.device != null && row.device.id == deviceUdid) {
                            return row;
                        }
                    });
                    list[0].num = find === null || find === void 0 ? void 0 : find.sms;
                }
            } catch (error) {
                ;
            }
            setTypeModule(list);
            localStorage.setItem("userSummary", JSON.stringify(list));
            if (window.localStorage.getItem("addDevice") == "1") {
                setTimeout(()=>{
                    localStorage.removeItem("addDevice");
                }, 1000 * 3);
            }
        } finally{
            if (deviceRequestKeyRef.current === requestKey) {
                setIsLoading(false);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let check = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        if (check == "") {
            localStorage.setItem("Basic", 0);
        }
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_6__/* .fetchResetTime */ .NZ)());
        const timer = setTimeout(()=>{
            getData(deviceRequestKey);
        }, 1500);
        return ()=>clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        deviceRequestKey
    ]);
    const [tips, setTips] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [orderData, setOrderData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [orderListData, setOrderListData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    // 当前设备的平台类型。必须以【设备接口】user-device 为准：
    // 订单接口 user-account-order 的 platform_type 是「购买的产品」，
    // 不等于当前设备类型（安卓设备的订单也可能是 iOS 产品，反之亦然）。
    const [currentDevicePlatform, setCurrentDevicePlatform] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [currentIndex, setCurrentIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [orderIndex, setOrderIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [showDeviceList, setShowDeviceList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showOrderList, setShowOrderList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [targetDeviceList, setTargetDeviceList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const orderListRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const toggleButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 绑定按钮引用
    ;
    // 点击按钮显示/隐藏弹窗
    const handleClickOutside = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((event)=>{
        // 检查点击的地方是否在按钮或弹窗内
        if (showOrderList && orderListRef.current && !orderListRef.current.contains(event.target) && toggleButtonRef.current && !toggleButtonRef.current.contains(event.target)) {
            setShowOrderList(false);
        }
    }, [
        showOrderList
    ]);
    const changeOrder = (item, index)=>{
        setOrderListData(item);
        setOrderIndex(index);
        setShowOrderList(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    const FirstOrderData = async (requestKey)=>{
        // 设备接口失败不应连累订单卡片，故单独兜底为 null
        const [allDeviceUser, deviceRes] = await Promise.all([
            (0,src_api_login__WEBPACK_IMPORTED_MODULE_7__.getUserAccountOrder)({
                page: 1,
                pageSize: 9999
            }),
            (0,src_api_login__WEBPACK_IMPORTED_MODULE_7__.getAllUserDevice)({}).catch(()=>null)
        ]);
        if (deviceRequestKeyRef.current !== requestKey) return;
        // 当前设备类型取【设备接口】user-device，不能用订单接口的 platform_type。
        let storedDeviceUser = {};
        try {
            storedDeviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
        } catch (e) {
            storedDeviceUser = {};
        }
        const matchedDevice = (0,src_utils_refreshSubscriptionExpire__WEBPACK_IMPORTED_MODULE_15__/* .matchCurrentDevice */ .pG)(deviceRes === null || deviceRes === void 0 ? void 0 : deviceRes.data, storedDeviceUser);
        setCurrentDevicePlatform((matchedDevice === null || matchedDevice === void 0 ? void 0 : matchedDevice.platform_type) || "");
        let all = allDeviceUser.data;
        // 遍历数组并设置 `name` 属性
        all === null || all === void 0 ? void 0 : all.forEach((item, index)=>{
            item.name = "Acount".concat(String(index + 1).padStart(2, "0"));
        });
        setOrderData(all || []);
        if (all.length > 0) {
            let DeviceUser = null;
            try {
                DeviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "null");
            } catch (e1) {
                DeviceUser = null;
            }
            // 当前设备的关联订单：优先用设备接口的 order_id 直接命中订单主键；
            // 没有 order_id 时按 device_id 找，命中多张则取过期时间最晚的那张（最新的关联单）。
            let lastOrder = DeviceUser ? (0,src_utils_currentOrder__WEBPACK_IMPORTED_MODULE_19__/* .resolveDeviceOrder */ .mw)({
                orders: all,
                deviceUser: DeviceUser,
                device: matchedDevice
            }) : null;
            // 没有设备上下文（未选中任何设备）时才退回「全局过期最晚的一张」
            if (!lastOrder && !DeviceUser) {
                lastOrder = (0,src_utils_currentOrder__WEBPACK_IMPORTED_MODULE_19__/* .pickLatestExpireOrder */ .Ft)(all);
            }
            // 卡片展示以【设备接口】为准：user-device 现在直接返回
            // order_id / product_name / order_level / expire_time，就是这台设备当前的订阅状态；
            // 订单只用于补设备接口没有的字段（如 merchant_no → 注册码行）。
            setOrderListData((0,src_utils_currentOrder__WEBPACK_IMPORTED_MODULE_19__/* .resolveCardSubscription */ .Xm)({
                order: lastOrder,
                device: matchedDevice
            }));
        }
    };
    let { data: userData  } = JSON.parse(localStorage.getItem("userData"));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        FirstOrderData(deviceRequestKey);
    }, [
        deviceRequestKey
    ]);
    // 延长续订
    const [extendSubscriptionModal, setExtendSubscriptionModal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const extendSubscription = async ()=>{
        const renewId = await (0,src_utils_renewalPlans__WEBPACK_IMPORTED_MODULE_17__/* .fetchRenewProductIdForOrder */ .R4)(orderListData);
        if (!renewId) {
            window.dispatchEvent(new Event("renewalFailed"));
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)({
                content: t("Payment failed"),
                duration: 6
            });
            setExtendSubscriptionModal(false);
            return;
        }
        let result = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .extendSubscriptionTime */ .rK)({
            merchant_no: orderListData.merchant_no,
            renewId,
            order_type: 274
        });
        if (Number(result.code) === 0) {
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)({
                content: "".concat(result.msg),
                duration: 1.5
            });
            setExtendSubscriptionModal(false);
            // 与 iOS dashboard / ExpiredPurchaseGuide 一致：整页刷新，避免过期 banner/遮罩残留
            (0,src_utils_refreshSubscriptionExpire__WEBPACK_IMPORTED_MODULE_15__/* .reloadAfterRenewSuccess */ .dZ)();
            return;
        }
        window.dispatchEvent(new Event("renewalFailed"));
        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)({
            content: "".concat(result.msg),
            duration: 6
        });
        setExtendSubscriptionModal(false);
    };
    const openNav = ()=>{
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_6__/* .toggleNavVisibility */ .m_)(true));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_6__/* .setCurrentTab */ .Lw)(t("Dashboard")));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_6__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    // 埋点上报
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{}, []);
    const [favoriteArr, setFavoriteArr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const menuCacheRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({}) // { [device_id]: menuList }
    ;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const requestKey = deviceRequestKey;
        const init = async function() {
            let forceRefresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (!cloneList) return;
            const deviceUser = localStorage.getItem("DeviceUser");
            const device_id = deviceUser ? JSON.parse(deviceUser).device_id : "";
            if (!device_id) return;
            const cloneListMap = new Map(cloneList.map((item)=>[
                    (item.href || item.url).toLowerCase(),
                    item
                ]));
            let menuList = menuCacheRef.current[device_id];
            if (!menuList || forceRefresh) {
                menuList = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .getMenuFavorite */ .mz)(device_id);
                if (deviceRequestKeyRef.current !== requestKey) return;
                menuCacheRef.current[device_id] = menuList;
            }
            const hasInit = localStorage.getItem("menuFavoriteInit-".concat(device_id));
            if (!hasInit && (!(menuList === null || menuList === void 0 ? void 0 : menuList.data) || menuList.data.length === 0)) {
                localStorage.setItem("menuFavoriteInit-".concat(device_id), "true");
                await Promise.all([
                    (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .postMenuFavorite */ .fR)({
                        device_id: device_id,
                        name: "Text message",
                        url: "/android/text-messages",
                        status: true
                    }),
                    (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .postMenuFavorite */ .fR)({
                        device_id: device_id,
                        name: "Photo",
                        url: "/android/photos",
                        status: true
                    }),
                    (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .postMenuFavorite */ .fR)({
                        device_id: device_id,
                        name: "Email",
                        url: "/android/email",
                        status: true
                    }),
                    (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .postMenuFavorite */ .fR)({
                        device_id: device_id,
                        name: "WhatsApp",
                        url: "/android/whatsapp",
                        status: true
                    })
                ]);
                if (deviceRequestKeyRef.current !== requestKey) return;
                let retry = 3;
                while(retry > 0){
                    menuList = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .getMenuFavorite */ .mz)(device_id);
                    if (deviceRequestKeyRef.current !== requestKey) return;
                    if ((menuList === null || menuList === void 0 ? void 0 : menuList.data) && menuList.data.length > 0) break;
                    await new Promise((resolve)=>setTimeout(resolve, 100));
                    retry--;
                }
                menuCacheRef.current[device_id] = menuList;
            }
            const result = ((menuList === null || menuList === void 0 ? void 0 : menuList.data) || []).map((item)=>cloneListMap.get(item.url.toLowerCase())).filter(Boolean);
            if (deviceRequestKeyRef.current !== requestKey) return;
            setFavoriteArr(result);
        };
        init();
        const handler = ()=>init(true) // 强制刷新
        ;
        window.addEventListener("menuUpdated", handler);
        return ()=>{
            window.removeEventListener("menuUpdated", handler);
        };
    }, [
        cloneList,
        deviceRequestKey
    ]);
    // 卡片上判断「是不是 iOS / 安卓」一律用设备类型（设备接口），
    // 订单类型只作为设备类型取不到时的兜底，避免改变原有表现。
    const cardPlatformType = currentDevicePlatform || (orderListData === null || orderListData === void 0 ? void 0 : orderListData.platform_type) || "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            userSelect: "none"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ExpirationReminder__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                orders: orderData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DisconnectDetection__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative min-h-[calc(var(--vh2)*100-90px)]",
                children: [
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                        container: true,
                        spacing: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            md: 12,
                            lg: 12,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    style: {
                                        width: "100%",
                                        marginBottom: "20px"
                                    },
                                    className: "".concat(favoriteArr.length === 0 && "hidden"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full flex justify-between items-center mb-[10px] px-[18px] pt-4",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-[18px] text-[#222] font-[600]",
                                                children: t("Favorites")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            style: {
                                                display: "flex",
                                                flexWrap: "wrap"
                                            },
                                            children: favoriteArr.map((row)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                                    item: true,
                                                    xs: 4,
                                                    md: 3,
                                                    lg: 2,
                                                    style: {
                                                        position: "relative",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        marginBottom: "10px"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                        className: "flex flex-col items-center justify-center",
                                                        href: row.href,
                                                        onClick: ()=>{},
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "w-[50px] h-[50px] relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                        src: row.img,
                                                                        alt: "img",
                                                                        width: 50,
                                                                        height: 50,
                                                                        className: "mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center",
                                                                        children: row.num
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center",
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: t(row.name)
                                                            })
                                                        ]
                                                    })
                                                }, row.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex justify-between items-center mb-[10px] px-[18px] pt-4",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: "text-[18px] text-[#222] font-[600] Bxls:hidden",
                                                    children: t("Hot features")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: "text-[18px] text-[#222] font-[600] hidden Bxls:block",
                                                    children: t("Features")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: " border-0 px-[10px] h-[30px] rounded-[22.5px] hover:bg-[#454CFF] text-[#454CFF] hover:text-[#FFF] text-[12px] Bxls:hidden flex items-center font-[600]",
                                                    onClick: openNav,
                                                    children: t("SEE ALL")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            style: {
                                                display: "flex",
                                                flexWrap: "wrap"
                                            },
                                            children: cloneList.map((row)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                                    item: true,
                                                    xs: 4,
                                                    md: 3,
                                                    lg: 2,
                                                    style: {
                                                        position: "relative",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        marginBottom: "10px"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                        className: "flex flex-col items-center justify-center",
                                                        href: row.href,
                                                        onClick: ()=>{},
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "w-[50px] h-[50px] relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                        src: row.img,
                                                                        alt: "img",
                                                                        width: 50,
                                                                        height: 50,
                                                                        className: "mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center",
                                                                        children: row.num
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center",
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: t(row.name)
                                                            })
                                                        ]
                                                    })
                                                }, row.id))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-3 Hsm:grid-cols-2 Hsm:Dsm:grid-cols-1 w-full gap-[20px] mt-[20px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[30px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex justify-between items-center relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "text-[18px] text-[#222] font-[600]",
                                            children: t("Account")
                                        }),
                                        showOrderList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            ref: orderListRef,
                                            className: "bg-[#FFF] w-full absolute left-0 top-[40px] z-10 rounded-[8px] p-[8px] drop-shadow-[0_4px_8px_rgba(0,0,0,0.13)] overflow-auto",
                                            children: orderData.map((row, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    onClick: ()=>changeOrder(row, index),
                                                    className: "hover:bg-[#F4F5F6] hover:cursor-pointer px-[15px] py-[10px] ".concat(orderIndex === index ? "bg-[#F4F5F6]" : ""),
                                                    children: row.name
                                                }, index))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full h-[1px] bg-[#E5E5E5] mt-[20px] mb-[24px]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full h-auto flex flex-col justify-between text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex justify-between items-center h-[36px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "text-[#334062]",
                                                    children: [
                                                        t("Product"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-[#9198AD]",
                                                    children: cardPlatformType
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex justify-between items-center h-[36px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "text-[#334062]",
                                                    children: [
                                                        t("Subscription Plan"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "text-[#9198AD]",
                                                    children: [
                                                        cardPlatformType === "iOS-Cloud" && ((0,src_utils_orderLevel__WEBPACK_IMPORTED_MODULE_23__/* .isBasicOrderLevel */ .$w)(orderListData === null || orderListData === void 0 ? void 0 : orderListData.order_level) ? "".concat(t("Basic"), " - ") : "Extreme - "),
                                                        orderListData === null || orderListData === void 0 ? void 0 : orderListData.product_name
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex justify-between items-center h-[36px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "text-[#334062]",
                                                    children: [
                                                        t("Expiry Date"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-[#9198AD]",
                                                    children: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(orderListData === null || orderListData === void 0 ? void 0 : orderListData.expire_time).format("YYYY-MM-DD")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex justify-between items-center h-[36px] ".concat(cardPlatformType.includes("Android") && new Date(orderListData === null || orderListData === void 0 ? void 0 : orderListData.expire_time) > new Date() ? "block" : "hidden"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "text-[#334062]",
                                                    children: [
                                                        t("Registration Code"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-[#9198AD]",
                                                    children: orderListData === null || orderListData === void 0 ? void 0 : (ref = orderListData.merchant_no) === null || ref === void 0 ? void 0 : ref.slice(-8)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "text-[#454CFF] w-full h-[45px] border border-[#454CFF] rounded-[22.5px] mt-[36px] hover:bg-[#454CFF] hover:text-[#FFF]",
                                    onClick: ()=>setExtendSubscriptionModal(true),
                                    children: t("Extend subscription")
                                })
                            ]
                        })
                    })
                ]
            }),
            Basic ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_android_login__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {}) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                open: tips,
                onCancel: ()=>setTips(false),
                footer: [],
                zIndex: 1200,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("Currently you have only purchased the Android monitoring package If you want to monitor an iPhone please click the button")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            textAlign: "center",
                            marginTop: "20px",
                            padding: "8px 22px",
                            borderRadius: "10px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                            target: "_blank",
                            href: "https://test-ms-web.gbyte.com.cn" + "/choose-monitored-device",
                            style: {
                                background: "#07273D",
                                color: "#fff",
                                padding: "7px 14px",
                                borderRadius: "10px"
                            },
                            children: t("Add an iPhone device")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                open: extendSubscriptionModal,
                onCancel: ()=>setExtendSubscriptionModal(false),
                footer: [],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        style: {
                            marginTop: "10px",
                            fontWeight: "600"
                        },
                        children: t("After confirmation a new order will be produced to extend the equipment expiration time")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "14px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .ZP, {
                                onClick: ()=>extendSubscription(),
                                style: {
                                    marginRight: "10px"
                                },
                                children: t("Confirm")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .ZP, {
                                onClick: ()=>setExtendSubscriptionModal(false),
                                children: t("Cancel")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Dashboard1);


/***/ }),

/***/ 23269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": function() { return /* binding */ isBasicOrderLevel; }
/* harmony export */ });
/* unused harmony export resolveOrderLevel */
/**
 * 订单等级（订阅档位）归一化。
 *
 * 后端 order_level 的取值：
 *   1 = 初级（Basic）
 *   2 = 高级（Extreme）
 *
 * 历史遗留：增值服务（初级 / 高级分档）上线之前，老用户买的产品包**没有分档**，
 * 这些订单的 order_level 为 null（少数情况下是字符串 'null'）。按业务约定，
 * 这类订单一律**视为 2（高级）**。
 *
 * 因此本函数只在**明确等于 1** 时返回 1，其余（null / 'null' / undefined /
 * 其他非法值）一律返回 2。
 *
 * 之所以显式归一化，而不是直接用 `Number(order_level) === 1`：
 * 后者虽然对 null 也"碰巧"得到 Extreme（Number(null) === 0），但那只是巧合，
 * 一旦有人把判断改成 `=== 2 ? 'Extreme' : 'Basic'` 就会把老用户错判成初级。
 *
 * @param {*} orderLevel - 订单接口返回的 order_level
 * @returns {1|2} 归一化后的档位
 */ const resolveOrderLevel = (orderLevel)=>Number(orderLevel) === 1 ? 1 : 2;
/**
 * 是否为初级（Basic）档位。
 * 历史老用户（order_level 为 null）按高级处理，这里返回 false。
 *
 * @param {*} orderLevel - 订单接口返回的 order_level
 * @returns {boolean}
 */ const isBasicOrderLevel = (orderLevel)=>resolveOrderLevel(orderLevel) === 1;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (resolveOrderLevel)));


/***/ }),

/***/ 27856:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ debounce; }
/* harmony export */ });
/* unused harmony export throttle */
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */
function throttle (delay, callback, options) {
  var _ref = options || {},
    _ref$noTrailing = _ref.noTrailing,
    noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
    _ref$noLeading = _ref.noLeading,
    noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
    _ref$debounceMode = _ref.debounceMode,
    debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false;

  // Keep track of the last time `callback` was executed.
  var lastExec = 0;

  // Function to clear existing timeout
  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  }

  // Function to cancel next exec
  function cancel(options) {
    var _ref2 = options || {},
      _ref2$upcomingOnly = _ref2.upcomingOnly,
      upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }

  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */
  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }
    var self = this;
    var elapsed = Date.now() - lastExec;
    if (cancelled) {
      return;
    }

    // Execute `callback` and update the `lastExec` timestamp.
    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }

    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */
    function clear() {
      timeoutID = undefined;
    }
    if (!noLeading && debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */
      exec();
    }
    clearExistingTimeout();
    if (debounceMode === undefined && elapsed > delay) {
      if (noLeading) {
        /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */
        lastExec = Date.now();
        if (!noTrailing) {
          timeoutID = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      }
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }
  wrapper.cancel = cancel;

  // Return the wrapper function.
  return wrapper;
}

/* eslint-disable no-undefined */

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */
function debounce (delay, callback, options) {
  var _ref = options || {},
    _ref$atBegin = _ref.atBegin,
    atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
  return throttle(delay, callback, {
    debounceMode: atBegin !== false
  });
}


//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3498,5675,5432,9830,5170,1954,1033,8914,3368,2862,770,1664,2586,6456,6886,8791,1978,5741,9166,2870,726,2912,8449,9774,2888,179], function() { return __webpack_exec__(14060); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);